import { GenericProductDisplayer } from '@components';
import React from 'react';

export const EpiCategoryPage: React.FC = () => {
    return <GenericProductDisplayer type="epi" basePath="/sante-securite/epi" />;
};
